module.exports = __webpack_public_path__ + "img/app-4.a00e3a0a.png";